// Used at the begining of every page, contains image banner and buttons
import NavButton from '../components/NavButton.js';
import '../style/header.css';
import toggleNavMobile from '../utils/toggleNavMobile.js';

function Header() {
    return (
        <>
            <div class='header-content'>
                <div class='header-overlay'>
                    <h1>Borealis Blades Historical Fencing</h1>
                </div>
            </div>
            <nav class='top-nav' id='top-nav'>
                <button class='nav-mobile-toggle' onClick={toggleNavMobile}>
                    <i>Menu</i>
                </button>
                <NavButton url='/' value='Home' />
                {/*Events page is commented out until needed, don't forget to uncomment in Header.js*/}
                {/*<NavButton url='/events' value='Events' />*/}
                <NavButton url='/faq' value='FAQ' />
                <NavButton url='/gallery' value='Gallery' />
                <NavButton url='/join' value='Join Us' />
                <NavButton url='/our-story' value='Our Story' />
                <NavButton url='/resources' value='Resources' />
            </nav>
        </>
    );
}

export default Header;